/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';

import { actions as toastActions } from '~/redux/reducers/toast';
import { actions as sessionActions } from '~/redux/reducers/session';

import Link from '~/components/Link/Link';
import { path } from '~/utils/media';
import { getInstantUrl } from '~/utils/helpers';
import Colors from '~/utils/colors';
import config from '~/config';

moment.tz.setDefault('Asia/Bangkok');

const ToastContainer = styled.div`
  &.toasts-container {
    transition: 1s all;
    z-index: 8000;
    position: fixed;
    width: 400px;
    top: 87px;
    right: -400px;
    padding-right: 10px;
    &.with-black-friday {
      transition: none;            
      width: 100%;
      top: -50px;
      padding-right: 0;
      z-index: 4001;
      @media(max-width: 700px) {
        top: 55px;
        transition: .5s all;
      }
    }
    @media (max-width: 700px) {
      width: 100%;
      top: 55px !important;
      padding-right: 0;
      left: 100%;
      right: 0;
    }
  }
  &.toasts-container-in {
    right: 0;
    &.with-black-friday {
      top: 0;
    }
    @media (max-width: 700px) {
      left: 0;
    }
  }
`;

const ToastNoti = styled.div`
  &.toast-in {
    transition: .5s all;
    width: 390px;
    max-height: 400px;
    display: flex;
    border-radius: 5px;
    border: 1px solid ${Colors.borderGray};
    justify-content: space-between;
    margin-bottom: 10px;
    color: ${Colors.white};
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    @media (max-width: 700px) {
      border: 0;
      border-radius: 0;
      width: 100%;
    }
    &.black-friday-toast {
      transition: none;           
      width: 100%;
      border: none;
      border-radius: 0px;
      background-color: ${Colors.blue};
      color: ${Colors.white};
      @media(max-width: 700px) {
        transition: .5s all;
      }
    }
  }
  &.toast-noti-in {
    color: ${Colors.gray};
    background: ${Colors.white};
    @media (max-width: 700px) {
      border: 1px solid ${Colors.borderGray};
    }
  }
`;

const ToastNormal = styled.div`
  &.toast {
    transition: .5s all;
    max-height: 0;
    display: flex;
    visibility: hidden;
    opacity: 0;
    color: transparent;
    margin-bottom: 0;
    &.black-friday-toast {
      transition: none;
      @media(max-width: 700px) {
        transition: .5s all;
      }
    }
  }
  &.toast-in {
    transition: .5s all;
    width: 390px;
    max-height: 400px;
    display: flex;
    border-radius: 5px;
    border: 1px solid ${Colors.borderGray};
    justify-content: space-between;
    margin-bottom: 10px;
    color: ${Colors.white};
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    @media (max-width: 700px) {
      border: 0;
      border-radius: 0;
      width: 100%;
    }
    &.black-friday-toast {
      transition: none;           
      width: 100%;
      border: none;
      border-radius: 0px;
      background-color: ${Colors.blue};
      color: ${Colors.white};
      @media(max-width: 700px) {
        transition: .5s all;
      }
    }
  }
  &.toast-success-in {
    background: ${Colors.green};
  }
  &.toast-warning-in {
    background: ${Colors.warningYellow};
  }
  &.toast-error-in {
    background: ${Colors.red};
  }
`;

const ToastContentContainer = styled.div`
  flex: 1;
  padding: 10px;
  display: flex;
  align-items: center;
  >p {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 400;
  }
  ${props => props.promo && `
    padding: 0;
    text-align: center;
  `}
`;

const BlackFridayLink = styled.p`
  display: block;
  width: 100% !important;
  color: ${Colors.white} !important;
  box-sizing: border-box;
  padding: 0 5px;
  font-size: 18px;
  >a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60px;
    box-sizing: border-box;
    padding: 10px 0;
    @media(max-width: 700px) {
      min-height: 40px;
      font-size: 12px;
    }
    > span {
      color: ${Colors.white} !important;
    }
  }
  &:hover {
    text-decoration: none !important;
  }
`;

const NotiPic = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border: 1px solid ${Colors.borderGray};
  background-color: transparent;
  background-image: url('${config.assetPath}/static/images/default-img.jpg');
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  border-radius: 50%;
  box-sizing: border-box;
  @media (max-width: 700px) {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
  }
  &.noti-redeem-pic {
    background-image: url('${config.assetPath}/static/icons/coin.png');
  }
  &.instant-pic {
    background-image: url('${config.assetPath}/static/icons/instant-orange.png');
  }
`;

const NotiMessage = styled.p`
  flex: 1px;
  margin-left: 10px;
  &.black-friday-msg {
    text-align: center;
    font-size: 16px;
    @media(max-width: 700px) {
      font-size: 12px;
    }
  }
`;

const CloseContainer = styled.div`
  width: 30px;
  min-width: 30px;
  border-left: 1px solid ${Colors.borderGray};
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  &.close-white {
    color: ${Colors.white};
    border-left: none;
  }
  @media (max-width: 700px) {
    width: 38px;
    min-width: 38px;
  }
`;

const toastLink = css `
  color: inherit;
  flex: 1;
  &:visited {
    color: inherit;
    flex: 1;
  }
`;

const ToastLink = styled(Link)`
  ${toastLink}
`;

const ToastLinkDiv = styled.div`
  ${toastLink}
`;

const enhance = connect(
  state => ({
    show: state.toast.show,
    type: state.toast.type,
    toasts: state.toast.toasts,
    sessionData: state.session.data,
  }), {
    ...toastActions,
    ...sessionActions
  }
);

class Toast extends Component {
  static propTypes = {
    toasts: PropTypes.array,
    closeToast: PropTypes.func,
    logClickToast: PropTypes.func,
    sessionData: PropTypes.object,
    // setSessionData: PropTypes.func
  }

  componentWillUpdate(props) {
    if (this.props.toasts.length < props.toasts.length) {
      const last = props.toasts[props.toasts.length - 1];
      if (last.id && last.timeout > 0) {
        setTimeout(() => this.props.closeToast(last.id), last.timeout);
      }
    }
  }

  closeToast(id) {
    document.cookie = 'is_close_blackfriday=true; path=/;';
    this.props.closeToast(id);
  }

  clickRedeemReminder(id, code) {
    this.props.logClickToast('promo_code', code);
    if (code === 'BLACKFRI17') {
      document.cookie = 'is_close_blackfriday=true; path=/;';
      // this.props.setSessionData({ promo: 'BLACKFRI17' });
    }
    this.props.closeToast(id);
  }

  clickInstantTomorrow(id) {
    this.props.logClickToast('instant_tomorrow');
    this.props.closeToast(id);
  }

  render() {
    const { toasts, sessionData } = this.props;
    const count = toasts.filter((t)=> t.closed).length;
    const instantUrl = getInstantUrl();
    const blackFridayToast = toasts.find(t => t.code === 'BLACKFRI17');
    const hasBlackFridayToast = blackFridayToast ? !blackFridayToast.closed : false;
    return (
      <ToastContainer
        className={`toasts-container ${toasts.length > count ? 'toasts-container-in' : ''} ${hasBlackFridayToast ? 'with-black-friday' : ''}`}
      >
        {toasts.map((t, i)=> {
          if (t.type === 'noti') {
            return (
              <ToastNoti className={t.closed ? 'toast-noti' : 'toast-noti-in'} key={t.id}>
                <ToastLink to={t.link} onClick={this.closeToast.bind(this, t.id)}>
                  <ToastContentContainer className="toast-content-container">
                    {t.is_admin !== 'admin'
                      && <NotiPic style={t && t.sender_id && t.sender_id.avatar_image && path(t.sender_id.avatar_image, 'profileNoti', true)} />
                    }
                    <NotiMessage>{t.message}</NotiMessage>
                  </ToastContentContainer>
                </ToastLink>
                <CloseContainer onClick={this.closeToast.bind(this, t.id)}>
                  <i className="fa fa-times"></i>
                </CloseContainer>
              </ToastNoti>
            );
          }
          if (t.type === 'instant') {
            return (
              <div className={t.closed ? 'toast-noti' : 'toast-noti-in'} key={t.id}>
                <ToastLink to={instantUrl} onClick={this.clickInstantTomorrow.bind(this, t.id)}>
                  <ToastContentContainer className="toast-content-container">
                    <NotiPic className="instant-pic" />
                    <NotiMessage>
                      Book a tour for tomorrow here.
                    </NotiMessage>
                  </ToastContentContainer>
                </ToastLink>
                <CloseContainer onClick={this.closeToast.bind(this, t.id)}>
                  <i className="fa fa-times"></i>
                </CloseContainer>
              </div>
            );
          }
          if (t.type === 'redeem') {
            const upsellText = sessionData && sessionData.country === 'TH'
              ? <span>Up to 60% OFF instant tickets for must-see attractions in Thailand <b>More details</b></span>
              : <span>Special Offer 35% OFF: Data Roaming Package (Airport Pickup) <b>Book now</b></span>;
            const upsellLink = sessionData && sessionData.country === 'TH'
              ? '/article/thailand-attraction-ticket-travel-product?utm_source=upsell_toast_promoteticket&utm_medium=homepage&utm_campaign=upsell'
              : '/trip/happy-tourist-sim-card-8-days?utm_source=upsell_toast_promotesim&utm_medium=homepage&utm_campaign=upsell';
            return (
              <div className={t.closed ? 'toast toast-noti' : `toast-in toast-noti-in ${t.code === 'BLACKFRI17' && 'black-friday-toast'}`} key={t.id}>
                <ToastLinkDiv onClick={this.clickRedeemReminder.bind(this, t.id, t.code)}>
                  <ToastContentContainer promo={t.code === 'BLACKFRI17'}>
                    {t.code !== 'BLACKFRI17' && <NotiPic className="noti-redeem-pic" />}
                    {t.expires_at // eslint-disable-line
                      ? (
                        t.code === 'BLACKFRI17'
                          ? (
                            <BlackFridayLink>
                              <a href={upsellLink}>
                                <span style={{ color: Colors.white, textDecoration: 'none' }}>
                                  {upsellText}
                                </span>
                              </a>
                            </BlackFridayLink>
                          )
                          : (
                            <NotiMessage>
                              <span>You&apos;ve got {t.percentage ? `${t.percentage * 100}%` : `${t.constant} ${t.currency}`} discount code. Browse & Book a trip before {moment(t.expires_at).format('ll')}.</span>
                            </NotiMessage>
                          )
                      )
                      : (
                        <NotiMessage>
                          <span>You&apos;ve got {t.percentage ? `${t.percentage * 100}%` : `${t.constant} ${t.currency}`} discount code. Browse & Book a trip now.</span>
                        </NotiMessage>
                      )
                    }
                  </ToastContentContainer>
                </ToastLinkDiv>
                <CloseContainer className={t.code === 'BLACKFRI17' ? 'close-white' : ''} onClick={this.closeToast.bind(this, t.id)}>
                  <i className="fa fa-times"></i>
                </CloseContainer>
              </div>
            );
          }
          const type = t.type || 'success';
          const toastContent = [
            <ToastContentContainer className="toast-content-container" key={`content-${i}-0`}>
              <p>{t.message}</p>
            </ToastContentContainer>,
            <CloseContainer className="tmt-mobile-hide" key={`content-${i}-1`}>
              <i className="fa fa-times"></i>
            </CloseContainer>
          ];
          if (t.link) {
            return (
              <Link onClick={this.closeToast.bind(this, t.id)} key={t.id} to={t.link} >
                <ToastNormal className={t.closed ? `toast toast-${type}` : `toast-in toast-${type}-in`}>
                  {toastContent}
                </ToastNormal>
              </Link>
            );
          }
          return (
            <ToastNormal className={t.closed ? `toast toast-${type}` : `toast-in toast-${type}-in`} onClick={this.closeToast.bind(this, t.id)} key={t.id}>
              {toastContent}
            </ToastNormal>
          );
        })}
      </ToastContainer>
    );
  }
}

export default enhance(Toast);
